import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { CampaignType } from "../../../../../../@types/gamification";
import { CampaignLinkBlock } from "../../../components/campaign-link-block";
import { MechanicConfigSection } from "../../../components/mechanic-config-section";
import type { SlugAvailability } from "../../../hooks/use-slug-availability";
import { type CreateGamificationFormData } from "../../../validations/gamification.validation";

interface StepConfigProps {
  slugAvailability: SlugAvailability;
}

export const StepConfig: React.FC<StepConfigProps> = ({ slugAvailability }) => {
  const form = useFormContext<CreateGamificationFormData>();
  const campaignType =
    useWatch({ control: form.control, name: "campaignType" }) ??
    CampaignType.ROULETTE;

  return (
    <MechanicConfigSection
      campaignType={campaignType}
      control={form.control}
      register={form.register}
      errors={form.formState.errors}
      generalLead={<CampaignLinkBlock availability={slugAvailability} />}
    />
  );
};
